export default __webpack_public_path__ + "static/media/phone.4b8e9b73.svg";